import AgendaPage from './AgendaPage';

export default AgendaPage;